import { Pipe, PipeTransform } from "@angular/core";
import { TaskStatus } from "@models/task-request";

@Pipe({
  name: "requestStatusEnum",
  standalone: true,
})
export class RequestStatusEnumPipe implements PipeTransform {
  transform(value: TaskStatus): unknown {
    switch (value) {
      case TaskStatus.APPROVED:
        return "Aprovado";
      case TaskStatus.REJECTED:
        return "Rejeitado";
      case TaskStatus.PENDING:
        return "Pendente";
      default:
        return value;
    }
  }
}
